export const VERSION_SIZE = 4;
export const LOCKTIME_SIZE = 4;
export const P2PKH_INPUT_SIZE = 32 + 4 + 1 + 1 + 65 + 1 + 33 + 4;
//# sourceMappingURL=constants.js.map